package com.crowpay

import com.crowpay.sdk.*
import com.crowpay.views.components.nav.crowpay
import com.crowpay.views.screens.auth.LogInScreen
import com.lightningkite.kiteui.exceptions.ExceptionToMessages
import com.lightningkite.kiteui.exceptions.installLsError
import com.lightningkite.kiteui.navigation.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.serialization.ClientModule
import com.lightningkite.serialization.SerializationRegistry

enum class NavOption(val display: String) {
    Home("Home"),
    Projects("Projects"),
    Clients("Clients"),
    Tasks("Tasks"),
    Messages("Messages"),
    Finances("Finances"),
    DevProjects("Dev Projects"),
    None("");
}

fun ViewWriter.app(main: ScreenNavigator, dialog: ScreenNavigator) {
    prepareModelsShared()
    SerializationRegistry.master.register(URLs.JumpTo.serializer())
    com.lightningkite.prepareModelsShared()
    ExceptionToMessages.root.installLsError()
    ExceptionToMessages.root += RequestException.Handler


    DefaultSerializersModule = ClientModule
    screenNavigator = main
    mainScreenNavigator = main
    dialogScreenNavigator = dialog
    main.bindToPlatform(context)

    sessionNotFound.addListener {
        mainScreenNavigator.reset(LogInScreen())
    }

    crowpay()
}